<template>
 <page>

   <head-nav title="language.update_calendar_item">
      <icon-button-back slot="left"></icon-button-back>
      <icon-button-home slot="right"></icon-button-home>
    </head-nav>

<scroll-page>
    <page-padding>
      <ui-input title="language.date" type="date" v-bind:val="date" @input="(v)=>{date = v}"></ui-input>
      <ui-input title="language.time_from" type="time" v-bind:val="timeFrom" @input="(v)=>{timeFrom = v}"></ui-input>
      <ui-input title="language.time_to" type="time" v-bind:val="timeTo" @input="(v)=>{timeTo = v}"></ui-input>
      <ui-input title="language.title" type="text" v-bind:val="title" @input="(v)=>{title = v}"></ui-input>
      <ui-textarea title="language.provide_description" v-bind:val="description" @input="(v)=>{description = v}"></ui-textarea>
      
      <divider title=""/>
      <button-activate :active="buttonActive" v-on:click.native="confirm()" :title="computeTitle"></button-activate>
     </page-padding>
</scroll-page>
   </page>
</template>

<script>

import { mapState } from 'vuex';
import Page from '../pages/Page.vue';
import ButtonActivate from '../components/buttons/ButtonActivate.vue';
import PagePadding from '../components/PagePadding.vue';
import ScrollPage from '../components/ScrollPage.vue';
import HeadNav from '../components/HeadNav.vue';
import IconButtonHome from '../components/buttons/IconButtonHome.vue';
import IconButtonBack from '../components/buttons/IconButtonBack.vue';
import UiInput from '../components/UiInput.vue';
import UiTextarea from '../components/UiTextarea.vue';
import { modalService } from '../services/ModalService.js';
import i18n from "../language.js";
import { history } from "../services/History.js";
import Divider from '../components/dividers/Divider.vue';

export default {
  name: 'update-calendar-item-page',
  data:function(){
    return{
      id:this.$route.params.id,
      prevRoute:"",
      title:"",
      description:"",
      buttonActive:true,
      date:"",
      timeFrom:"",
      timeTo:""
    }
  },
  computed:{
     ...mapState([
       'calendar_item'
       ]),
       computeTitle(){
        if(!this.buttonActive){
          return this.$t('language.working');
        }else{
           return this.$t('language.update_calendar_item');
        }
      }
  },
  components: {
    ButtonActivate,
    PagePadding,
    HeadNav,
    IconButtonHome,
    IconButtonBack,
    UiInput,
    UiTextarea,
    Page,
    ScrollPage,
    Divider,
  },
  methods:{
    back(){
      this.$router.push(history.get());
    },
    isFormComplete(){
      
      if(this.date===""){
          modalService.createAlert(i18n.t('language.form_incomplete_date'))
        return false;
      }

      if(this.title===""){
          modalService.createAlert(i18n.t('language.form_incomplete_title'))
        return false;
      }

      return true
    },
    initForm(){
      // set date to today;
      var today=new Date();
      var year=today.getFullYear();
      var month=(today.getMonth()+101).toString().slice(-2);
      var day=(today.getDate()+100).toString().slice(-2);
      // set date?
      this.date= year+"-"+month+"-"+day;

      var time = new Date();
      var hours = (time.getHours()+100).toString().slice(-2);
      var minutes = (time.getMinutes()+100).toString().slice(-2);
      time= hours+":"+minutes;

      this.timeFrom=time;
      this.timeTo=time;
    },
    convert_date_nl(){
      var date_us=this.date.split("-"); // yyyy-mm-dd;
      var date_nl=date_us[2]+'-'+date_us[1]+'-'+date_us[0]; // dd-mm-yyyy
      return date_nl;
    },
    convert_date_us(){
      // convert date from database to us format...
      // delete day and space from string and convert date to yyyy-MM-dd
      var date=this.calendar_item.date.split(',')[1].replace(/\s/g, '').split('-');
      var day=date[0];
      var month=date[1];
      var year=date[2];
      var newDateString=year+"-"+month+"-"+day;
      return newDateString
    },
    confirm(){
    
      if(!this.isFormComplete()){
        return;
      }

     this.buttonActive=false;
     setTimeout(()=>{
       this.updateCalendarItem();
      },500);

    },
    updateCalendarItem(){
       var payload={
        id:this.id,
        date:this.convert_date_nl(),
        time:this.timeFrom,
        end_time:this.timeTo,
        title:this.title,
        description:this.description,
      }

      // gets dummy promise that always resolves
      this.$store.dispatch('update_calendar_item',payload).then(
        ()=>{
          this.buttonActive=true;
          this.back();
        }
      )
    },
    loadCalendarItem(){
      // load calendar item
      var payload={id:this.id}
      this.$store.dispatch('get_calendar_item',payload).then(()=>{
        this.title=this.calendar_item.title;
        this.description=this.calendar_item.description;
        this.date=this.convert_date_us();
        this.timeFrom=this.calendar_item.start_time;
        this.timeTo=this.calendar_item.end_time;
      })
    },
    
  },
  mounted(){
    this.initForm();

    this.loadCalendarItem();
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
